import { DataProvider, TypeHelper } from "../../helpers"

import { Enums } from "../common"
import { IOpChangeState, IReferenceType, IOpObject, ICopyable } from "../util/interfaces"
import { OpDataList } from "../util"
import { OpDescr } from "./op-descr"
import { OpTechnicalPermissionData } from "./op-technical-permission-data"
import { Utils } from "../util/utils"


export class OpTechnicalPermission implements IReferenceType, IOpObject, ICopyable<OpTechnicalPermission> {

    //#region Properties

    public idTechnicalPermission: number
    public idDescr: number
    public name: string
    public code: string

    //#endregion


    //#region Navigation Properties

    private _descr: OpDescr = null
    public get descr(): OpDescr {
        return this._descr
    }
    public set descr(value: OpDescr) {
        this._descr = value
        this.idDescr = value != null ? value.idDescr : null
    }

    //#endregion


    //#region Custom Properties

    public dynamicValues: { Key: string; Value: any; }[];

    //#endregion


    //#region Ctor

    constructor(opObj: any) {
        if (opObj instanceof OpTechnicalPermission) {
            this.copy(<OpTechnicalPermission>opObj, true, true, true, true)
        } else {
            this.fromJSON(opObj)
        }
    }

    //#endregion


    //#region IReferenceType Implementation

    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.IdTechnicalPermission;
    }

    public getReferenceKey(): number {
        return this.idTechnicalPermission
    }

    public getReferenceValue() {
        return this
    }

    public toString(): string {
        if (this.descr != null) {
            return this.descr.toString()
        }

        return this.name
    }

    //#endregion


    //#region IOpChangeState Implementation

    public opState: Enums.OpChangeState = null

    //#endregion


    //#region IOpObject Implementation

    public get idObject(): any {
        return this.idTechnicalPermission
    }

    public set idObject(idObject: any) {
        this.idTechnicalPermission = idObject
    }

    public dataList: OpDataList<OpTechnicalPermissionData> = new OpDataList<OpTechnicalPermissionData>()
    public customFormatString: string;

    public toJSON(compressed: boolean) {
        return {
            ID_TECHNICAL_PERMISSION: this.idTechnicalPermission,
            ID_DESCR: this.idDescr,
            NAME: this.name,
            CODE: this.code,

            OpState: this.opState,
            DataList: this.dataList != null ? this.dataList.ToJSON() : null,
        }
    }

    public fromJSON(opObj: any, compressed: boolean = false) {
        if (opObj != null) {
            this.descr = opObj._Descr != null ? new OpDescr(opObj._Descr) : null

            this.idTechnicalPermission = opObj.ID_TECHNICAL_PERMISSION
            this.idDescr = opObj.ID_DESCR
            this.name = opObj.NAME
            this.code = opObj.CODE

            this.opState = opObj.OpState

            if (opObj.DataList != null) {
                this.dataList.push(...opObj.DataList.map((data: any) => new OpTechnicalPermissionData(data)))
            }
        } else {
            this.idTechnicalPermission = 0
            this.opState = Enums.OpChangeState.New
        }
    }

    //#endregion


    //#region ICopyable Implementation

    public clone(includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): OpTechnicalPermission {
        const newTechnicalPermission: OpTechnicalPermission = new OpTechnicalPermission(null)

        newTechnicalPermission.copy(this, includeNavigationProperties, includeCustomProperties, includeDataList, includeDynamicValues)

        return newTechnicalPermission
    }

    public copy(source: OpTechnicalPermission, includeNavigationProperties: boolean = false, includeCustomProperties: boolean = false, includeDataList: boolean = false, includeDynamicValues: boolean = false): void {
        if (source == null) {
            return null
        }

        if (includeNavigationProperties) {
            if (source.descr != null) {
                this.descr = source.descr
            }
        }

        // No customproperties

        if (includeDataList && source.dataList != null) {
            this.dataList = source.dataList.clone()
        }

        if (includeDynamicValues) {
            this.dynamicValues = TypeHelper.clone(source.dynamicValues, true)
        }

        this.idTechnicalPermission = source.idTechnicalPermission
        this.idDescr = source.idDescr
        this.name = source.name
        this.code = source.code

        this.opState = source.opState
    }

    //#endregion


    //#region LoadNavigationProperties

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpTechnicalPermission[]): JQueryPromise<OpTechnicalPermission[]> {
        return Utils.loadDataListNavigationProperties(dataProvider, list)
    }

    //#endregion
}